<div class="tab-content">
  <ul class="list">
    <li
      *ngFor="let achievement of achievements; trackBy: track"
      [innerHtml]="achievement | mojoHighlight: keywords"
    >
    </li>
  </ul>
</div>
